import { Box, styled } from "@mui/material";
import { Link } from "react-router-dom";
import { typographyStyles } from "./Typography";

const FooterContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  paddingBottom: "60px",
  "@media (max-width: 600px)": {
    paddingBottom: "32px",
    paddingLeft: "16px",
    paddingRight: "16px",
  },
}));

const FooterContent = styled(Box)(() => ({
  width: "100%",
  maxWidth: "1200px",
  padding: "100px 40px",
  backgroundColor: "var(--background-content)",
  borderRadius: "40px",
  display: "flex",
  gap: "20px",
  alignItems: "flex-start",
  transition: "background-color 0.3s ease",
  "&:hover": {
    backgroundColor: "rgba(226, 231, 233, 0.50)",
  },
  "@media (max-width: 600px)": {
    flexDirection: "column",
    padding: "20px",
    paddingTop: "106px",
    borderRadius: "24px",
    gap: "8px",
    width: "100%",
  },
}));

const FooterLink = styled(Link)(() => ({
  ...typographyStyles.p2,
  color: "var(--text-tertiary)",
  textDecoration: "none",
  cursor: "pointer",
  transition: "color 0.2s ease, opacity 0.2s ease",
  "&:hover": {
    color: "var(--text-primary)",
    opacity: 0.8,
  },
  "@media (max-width: 600px)": {
    fontSize: "14px",
    lineHeight: "17px",
    fontWeight: 600,
    color: "var(--text-primary)",
  },
}));

export const Footer = () => {
  return (
    <FooterContainer component="footer">
      <FooterContent>
        <FooterLink to="/privacy-policy">
          Политика конфиденциальности
        </FooterLink>
        <FooterLink to="/terms-of-service">
          Пользовательское соглашение
        </FooterLink>
      </FooterContent>
    </FooterContainer>
  );
};